export default __webpack_public_path__ + "locales/ko-KR/ChangeUserTypeDialog.json?hash=7006f995a16a4c4ebb4661c2f8473439";